// Client\client-vite\src\pages\Dealers\DealersLeadPage.tsx

export const DealersLeadPage = () => {
    return (
        <div>
            <h2>Dealers Lead Page</h2>
        </div>
    )
}

export default DealersLeadPage